import { render, staticRenderFns } from "./ReciepeList.vue?vue&type=template&id=022642aa&"
import script from "./ReciepeList.vue?vue&type=script&lang=js&"
export * from "./ReciepeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports